import {
  MouseEventHandler,
  FocusEventHandler,
  ChangeEventHandler,
  KeyboardEventHandler,
} from "react";
import Icon from "@Components/ui/icon";
import classes from "./SearchInput.module.scss";

interface ISearchRecipeInput {
  value?: string;
  placeholder?: string;
  onSearch?: MouseEventHandler<HTMLDivElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  onMagnifierClickSearch?: Function;
}

export const SearchInput = ({ ...resProps }: ISearchRecipeInput) => {
  /**
   * This function trigger the search query to Algolia when user press the magnifier icon in the search bar
   */
  const searchForProducts = () => {
    if (resProps && typeof resProps?.onMagnifierClickSearch === "function") {
      resProps?.onMagnifierClickSearch(resProps?.value);
    }
  };

  return (
    <div className={classes.container}>
      <div onClick={searchForProducts} className={classes.prefix}>
        <Icon iconName="magnifying-glass" />
      </div>
      <input type="text" className={classes.input} {...resProps} />
    </div>
  );
};
